import { LitElement, html, svg } from 'lit';

export class IconList16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>To rektangler under hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.5 2H15M5.5 8H15M5.5 14H15M1 2h.5M1 8h.5M1 14h.5"></path></svg>`; }
}
if (!customElements.get('f-icon-list16', IconList16)) {
  customElements.define('f-icon-list16', IconList16);
}